/*------------------------------------*\
 $GLOBAL VARIABLES
 \*------------------------------------*/
var $html = jQuery('html'),
	$body = jQuery('body'),
	$win = jQuery(window),
	$doc = jQuery(document),
	$t = jQuery(this);

var is_phone,
	touch,
	ltie9,
	lteie9,
	wh, ww,
	dh, ar,
	ieMobile,
	ua = navigator.userAgent;

var is_webkit = ua.match(/webkit/i);
var is_firefox = ua.match(/gecko/i);
var is_newer_ie = ua.match(/msie (9|([1-9][0-9]))/i);
var is_older_ie = ua.match(/msie/i) && !is_newer_ie;
var is_ancient_ie = ua.match(/msie 6/i);
var is_mobile = ua.match(/mobile/i);
var is_OSX = ( ua.match(/(iPad|iPhone|iPod|Macintosh)/g) ? true : false );
var is_android = ( ( ua.indexOf('Mozilla/5.0') > -1 && ua.indexOf('Android ') > -1 && ua.indexOf('AppleWebKit') > -1) && !( ua.indexOf('Chrome') > -1 ) );


/**
 * This is useful if you want to review all notices in the console.
 *
 * Set it to true if you want debug the code!
 */
var debug = true;

/*------------------------------------*\
 $SENSIBLE DEFAULTS
 \*------------------------------------*/
( function ( $, window, undefined ) {

	/**
	 *  DETECT VIEWPORT SIZE
	 */
	function browserSize() {
		wh = $win.height();
		ww = $win.width();
		dh = $doc.height();
		ar = ww / wh;
	}


	/**
	 *  DETECT PLATFORM
	 */
	function platformDetect() {

		$.support.touch = 'ontouchend' in document;

		var navUA = navigator.userAgent.toLowerCase(),
			navPlat = navigator.platform.toLowerCase();

		var is_iPhone = navPlat.indexOf('iphone'),
			is_iPod = navPlat.indexOf('ipod'),
			is_AndroidPhone = navPlat.indexOf('android'),
			is_safari = ( navUA.indexOf('safari') != -1 && navUA.indexOf('chrome') == -1 ) ? true : false,
			svgSupport = ( window.SVGAngle ) ? true : false,
			svgSupportAlt = ( document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1') ) ? true : false;

		is_phone = ( is_iPhone > -1 || is_iPod > -1 || is_AndroidPhone > -1 ) ? true : false;
		touch = $.support.touch ? true : false;
		ltie9 = $.support.leadingWhitespace ? false : true;
		lteie9 = typeof window.atob === 'undefined' ? true : false;

		ieMobile = navigator.userAgent.match(/Windows Phone/i) ? true : false;

		if ( touch || ieMobile ) {
			$html.addClass('touch');
		}

		if ( is_safari ) $body.addClass('safari');
		if ( is_phone ) $body.addClass('phone');

	}

});


/*------------------------------------*\
 $APP.JS
 \*------------------------------------*/
jQuery(document).ready(function ( $ ) {
	"use strict";

	/**
	 * $LAZY LOADING INIT
	 *
	 * When an image finished loaded add class to parent for
	 * the image to fade in
	 */
	function lazyLoad() {

		var $images = $('.lazy-load');

		$images.each(function () {

			var $img = $t,
				src = $img.attr('data-src');

			$img.on('load', function () {
				$img.closest('.mosaic__item').addClass('is-loaded');
			});

			$img.attr('src', src);

		});
	};

	/**
	 * $ON WINDOW LOAD
	 *
	 * When an image finished loaded add class to parent for
	 * the image to fade in
	 */
	$win.load(function () {
		if ( debug ) {
			console.group('OnWindowLoad');
		}

		lazyLoad();

		if ( debug ) {
			console.groupEnd();
		}
	});

	$('.down-arrow').click(function () {

		$('html, body').animate({
			scrollTop: $('.w-content').offset().top - $('header').height()
		}, 'fast');

	});

	$('.mobile-nav-btn').click(function () {

		$('nav').fadeToggle('fast');
		$(this).toggleClass('open');

	});

	$(window).on('resize', function () {

		if ( $(window).width() >= 992 ) {

			$('nav').css('display', 'block');
			$('.mobile-nav-btn').removeClass('open');

		} else if ( $(window).width() <= 991 ) {

			$('nav').css('display', 'none');

		}

	});

	if ( $(window).width() <= 991 ) {

		$('nav').find('a').click(function () {

			$('nav').css('display', 'none');
			$('.mobile-nav-btn').removeClass('open');

		});

	}

	var cboxOptions = {
		iframe: true,
		scrolling: false,
		innerWidth: '640',
		innerHeight: '360',
		returnFocus: false,
		trapFocus: false,
		closeButton: false
	};

	if ( $(window).width() >= 675 ) {

		$('.vimeo').colorbox(cboxOptions);

	}

	if ( $(window).height() >= 420 ) {

		$('.w-landing').css('height', 'calc( 100vh - 80px)');

	}

	$(window).scroll(function () {
		if ( $(window).scrollTop() > 50 && $('.mobile-nav-btn').is(':hidden') ) {
			$('#header').addClass('small-header');
		} else {
			$('#header').removeClass('small-header');
		}
	});

	new WOW({
		boxClass:     'wow',      // default
		animateClass: 'animated', // default
		offset:       0,          // default
		mobile:       false,       // default
		live:         true        // default
	}).init();

	// $('nav').find('a').each(function() {
	// 	$(this).removeAttr("href");
	// });


	//tijdelijke navigatie
	// $('#menu-item-58').click(function () {
	// 	$('html, body').animate({
	// 		scrollTop: $('h2:eq(0)').offset().top - 100
	// 	}, 'fast');
	// });
	//
	// $('#menu-item-57').click(function () {
	// 	$('html, body').animate({
	// 		scrollTop: $('h2:eq(1)').offset().top - 100
	// 	}, 'fast');
	// });
	//
	// $('#menu-item-56').click(function () {
	// 	$('html, body').animate({
	// 		scrollTop: $('h2:eq(2)').offset().top - 100
	// 	}, 'fast');
	// });
	//
	// $('#menu-item-55').click(function () {
	// 	$('html, body').animate({
	// 		scrollTop: $('h2:eq(3)').offset().top - 100
	// 	}, 'fast');
	// });
	//
	// $('#menu-item-61').click(function () {
	// 	$('html, body').animate({
	// 		scrollTop: $('#werken').offset().top - 100
	// 	}, 'fast');
	// });
	//
	// $('#menu-item-65').click(function () {
	// 	$('html, body').animate({
	// 		scrollTop: $('h2:eq(6)').offset().top - 100
	// 	}, 'fast');
	// });
});